<drawer [title]="formName + ' - ' + ('Form has errors detected by dry-run' | translate)"
  [isClosed]="isOpen ? false : true"
  [hideCancel]="true"
  [hideSave]="true"
  [contextVariant]="'danger'"
  [contextLabel]="errors && errors.length > 0 ? (errors.length + ' ' + ('Issues' | translate)) : ('No Issues' | translate)"
  [noContentPadding]="true"
  (closeEvent)="close()">
  <div class="drawer-content drawer-direct-content">
    <div class="table-items p-3" *ngIf="errors && errors.length > 0">

      <!-- Main group: "Forms" — same structure as dry-run groups -->
      <div class="row fields-group">
        <div class="col d-flex flex-column">

          <!-- Group Header -->
          <div class="row fields-group-header fields-group-header-collapsible flex-shrink-1"
            (click)="groupOpen = !groupOpen"
            [ngClass]="{'expanded': groupOpen}">
            <div class="col justify-content-between d-flex">
              <label class="input-label mb-0">
                {{ 'Forms' | translate }}
                <span class="badge badge-danger ml-2">{{ errors.length }}</span>
              </label>
              <i class="fas ml-auto mt-1"
                [ngClass]="{'fa-chevron-down': !groupOpen, 'fa-chevron-up': groupOpen}"
                aria-hidden="true"></i>
            </div>
          </div>

          <!-- Sub-groups (by parentName) -->
          <ng-container *ngIf="groupOpen">
            <div *ngFor="let subGroupEntry of subGroups | keyvalue" class="mt-2">
              <div class="text-body small font-weight-bold mb-1">{{ subGroupEntry.key }}</div>
              <div *ngFor="let p of subGroupEntry.value" class="row mb-1">
                <div class="col">
                  <div class="row d-flex align-items-center">
                    <a class="col d-flex align-items-center justify-content-start flex-wrap gap-2 cursor-pointer"
                      (click)="onItemClick(p)">
                      <div class="badge badge-danger">
                        {{ p.objectType | translate | replaceUnderscore }}
                      </div>
                      <span *ngIf="p.conflictingValue || subGroupEntry.key !== p.componentKey"
                        class="badge badge-light my-0">{{ formatTargetItem(p) }}</span>
                      <i class="far fa-ellipsis-v btn-xs btn-icon simple-icon cursor-pointer ml-auto"
                        [popover]="mistakeKeys" container="body" containerClass="confirmation-popover"
                        placement="right" triggers="mouseenter mouseleave" #pop="bs-popover"></i>
                      <ng-template #mistakeKeys>
                        <table class="m-0 table-small">
                          <thead>
                            <tr>
                              <th>{{ 'Conflicting value' | translate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <small>{{ p.objectId || p.conflictingValue }}</small>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </ng-template>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>

    </div>
    <div *ngIf="!errors || errors.length === 0" class="alert alert-info m-3">
      {{ 'No issues found' | translate }}
    </div>
  </div>
</drawer>
